import { PageProps } from 'gatsby';
import  React, { useEffect, useState } from 'react';

import { Box, Container, Stack, Typography } from '@mui/material';
import { AnalyticsPageType } from '@shopify/hydrogen-react';

import { JudgemeReviewWidget, useJudgeme } from '@judgeme/shopify-hydrogen';
import SeoHead from '../components/head';
import { HorizontalSlantContainer } from '../components/horizontal-slant-container';
import { useAnalytics } from '../shared/analytics';
import { headerSlantContainerNoContent } from '../shared/styles/headerSlantContainer';

export default function Review({ location }: PageProps) {
    // const theme = useTheme()
    // const isLargeMobile = useMediaQuery(theme.breakpoints.down("lg"))

    // const NotPrintable = styled('div')(notPrintable);
    const headerSlantContainerNoContentStyles = headerSlantContainerNoContent();
    useJudgeme({
        shopDomain: process.env.GATSBY_SHOPIFY_MYSHOPIFY_DOMAIN,
        publicToken: process.env.GATSBY_JUDGEME_PUBLIC_TOKEN,
        cdnHost: 'https://cdn.judge.me',
        delay: 0,
    });

    const [productId, setProductId] = useState('')

    useEffect(() => {
        const searchParams = new URLSearchParams(location?.search);
        setProductId(searchParams.get('pid'))
    }, [location])

    const analytics = useAnalytics();
    useEffect(() => {
        analytics.trackPageView(AnalyticsPageType.page);
    }, [])

    return (
        <>
            <HorizontalSlantContainer id={"reviews"} autoHeight>
                <Container sx={headerSlantContainerNoContentStyles}></Container>
            </HorizontalSlantContainer>

            <Container sx={{ pt: 6 }}>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="h1" gutterBottom>
                            Review your Bloo
                        </Typography>
                    </Box>

                    <JudgemeReviewWidget id={productId} />
                </Stack>
            </Container>
        </>
    )
}
export const Head = (props: PageProps) => {

    return (
        <SeoHead
            title="Review"
            pathname={props.location.pathname}
            description="Review your Methylene Blue"
        />
    )
}
